export default __webpack_public_path__ + "static/media/R.834944bb.wav";